<div class="detail-page">
  <div class="container">
    <div class="d-none d-lg-block pt-3">
      <div class="back-button" [routerLink]="'/rewards/wallet'">
        <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
      </div>
    </div>
  </div>

  <div class="widget-mobile">
    <div class="container mt-4">
      <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
    </div>
  </div>
</div>
